import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import LinkIcon from '@material-ui/icons/Link';
import { useTranslation } from 'react-i18next';
import BaseButton from 'components/form/BaseButton';
import SendIcon from '@material-ui/icons/Send';
// @ts-ignore
import AnyIssuesIcon from '@images/icons/svg/anyIssues.svg';
import { useQueryCached } from 'components/utils/graphql';
// @ts-ignore
import CancelIcon from '../../img/IconHeader/cancel.svg';
import UserReportedDrawer from '../UserIssues';
import { SideDrawer } from './SideDrawer';
import BridgeWidget from './BridgeWidget';
import { USER_ACADEMY } from '../../query/user';
import ACLWrapper from '../ACLWrapper';
import { CACHE_AND_NETWORK } from '../../lib/cache';
import BrowserCheck from './BrowserCheck';
import PlayerDataStatusWidget from '../webPlayerGbf/PlayerDataStatusWidget';
import GpexeVersion from '../GpexeVersion';
import InstallationMonitor from '../widgets/InstallationMonitor';

function AcademyAuthForm() {
  const [academyUser, setAcademyUser] = useState('');
  const [academyPwd, setAcademyPwd] = useState('');
  const [academyHost, setAcademyHost] = useState('');
  useQueryCached(USER_ACADEMY, {
    onCompleted: (data) => {
      setAcademyUser(data?.userAcademy?.login);
      setAcademyPwd(data?.userAcademy?.passwd);
      setAcademyHost(data?.userAcademy?.host);
    },
    ...CACHE_AND_NETWORK,
  });
  return (
    <form id="academy-login-form" action={`${academyHost}/wp-login.php`} method="post" hidden target="_blank">
      <input type="hidden" name="log" id="user_login" value={academyUser} />
      <input type="hidden" name="pwd" id="user_pass" value={academyPwd} />
    </form>
  );
}

function Footer(props: { menuIsOpen: boolean }) {
  const { t } = useTranslation();
  const { menuIsOpen } = props;

  const [contentOpen, setContentOpen] = useState(false);
  const [sendIssue, setSendIssue] = useState(false);
  const [blockSend, setBlockSend] = useState(true);
  const [blockReason, setBlockReason] = useState<string | null>(null);
  const warningMessage = t(
    'issues.content.placeholder.fieldsRequiredWarning',
    'category, title and description are required.',
  );

  const isDevelopOnProdServers = (
    process.env.NODE_ENV === 'development'
    && (
      process.env.GPEXE_BACKEND_URL?.indexOf('https://master.gpexe.com') === -1
      || process.env.GPEXE_GRAPH_URL?.indexOf('https://master.gpexe.com/ui/v2') === -1
    )
  );

  return (
    <Box
      className={`footer ${isDevelopOnProdServers ? 'warning-develop-on-prod' : ''}`}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      py={1}
      boxShadow={3}
      position="fixed"
      bottom={0}
      left={menuIsOpen ? 235 : 77}
      right={0}
      bgcolor="background.paper"
      color="text.primary"
      zIndex="99"
    >
      <Box className="academy-button">
        <ACLWrapper section="academy" type="view" permission="link_view">
          <BaseButton
            flat
            startIcon={<LinkIcon />}
            hoverAll
            onClick={() => (document.getElementById('academy-login-form') as HTMLFormElement)?.submit()}
          >
            {t('user.drawer.footer.academy')}
          </BaseButton>
        </ACLWrapper>
      </Box>
      <Box>
        <BrowserCheck />
        <PlayerDataStatusWidget />
        <Box display="flex" alignItems="center">
          <GpexeVersion />
          <InstallationMonitor />
        </Box>
      </Box>
      <Box id="bridge-chat-box">
        <BridgeWidget />
        <BaseButton
          startIcon
          isIconButton
          marginRight
          onClick={() => {
            setContentOpen(true);
          }}
          tooltipText="any issues?"
        >
          <AnyIssuesIcon style={{ color: '#828282' }} />
        </BaseButton>
      </Box>

      <SideDrawer
        open={contentOpen}
        setOpen={setContentOpen}
        title={t('issues.title', 'any issues? report here')}
        isLoading={sendIssue}
        customClasses="hide-on-screenshot"
        actionsLeft={[
          <BaseButton
            key="cancel"
            startIcon={<CancelIcon />}
            onClick={() => {
              setContentOpen(false);
            }}
            noMargins
          >
            {t('stats.drawer.button.cancel', 'cancel')}
          </BaseButton>,
        ]}
        actionsRight={[
          <BaseButton
            key="send"
            color="primary"
            startIcon={<SendIcon />}
            onClick={() => {
              setSendIssue(true);
            }}
            disabled={blockSend}
            isValidation={!blockSend}
            tooltipText={blockSend ? (blockReason || warningMessage) : undefined}
            noMargins
          >
            {t('header.action.submit', 'submit')}
          </BaseButton>,
        ]}
      >
        <UserReportedDrawer
          sendIssue={sendIssue}
          setSendIssue={setSendIssue}
          setContentOpen={setContentOpen}
          setBlockSend={setBlockSend}
          setBlockReason={setBlockReason}
        />
      </SideDrawer>
      <AcademyAuthForm />
    </Box>
  );
}

export default Footer;
